/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { EmployeeSummaryResource } from './';
import {
    EmployeeSummaryResourceFromJSON,
    EmployeeSummaryResourceFromJSONTyped,
    EmployeeSummaryResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectLotEmployeeCurrentResource
 */
export interface ProjectLotEmployeeCurrentResource {
    /**
     * 
     * @type {string}
     * @memberof ProjectLotEmployeeCurrentResource
     */
    correlationId: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectLotEmployeeCurrentResource
     */
    lotId?: string;
    /**
     * 
     * @type {Array<EmployeeSummaryResource>}
     * @memberof ProjectLotEmployeeCurrentResource
     */
    employees: Array<EmployeeSummaryResource>;
}

/**
 * Check if a given object implements the ProjectLotEmployeeCurrentResource interface.
 */
export function instanceOfProjectLotEmployeeCurrentResource(value: object): value is ProjectLotEmployeeCurrentResource {
    if (!('correlationId' in value) || value['correlationId'] === undefined) return false;
    if (!('employees' in value) || value['employees'] === undefined) return false;
    return true;
}

export function ProjectLotEmployeeCurrentResourceFromJSON(json: any): ProjectLotEmployeeCurrentResource {
    return ProjectLotEmployeeCurrentResourceFromJSONTyped(json, false);
}

export function ProjectLotEmployeeCurrentResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectLotEmployeeCurrentResource {
    if (json == null) {
        return json;
    }
    return {
        
        'correlationId': json['correlationId'],
        'lotId': json['lotId'] == null ? undefined : json['lotId'],
        'employees': ((json['employees'] as Array<any>).map(EmployeeSummaryResourceFromJSON)),
    };
}

export function ProjectLotEmployeeCurrentResourceToJSON(value?: ProjectLotEmployeeCurrentResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'correlationId': value['correlationId'],
        'lotId': value['lotId'],
        'employees': ((value['employees'] as Array<any>).map((v) => EmployeeSummaryResourceToJSON(v))),
    };
}

